////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> pedidos_cliente/?loja=            //
//                                                //
//  PÁGINA EXCLUSIVA PARA CLIENTES PARA           //
//  VISUALIZAR OS PRÓPRIOS PEDIDOS ANTERIORES.    //
//                                                //
//  NÃO RECEBE NADA COMO PARÂMETRO NA URL.        //
//                                                //
////////////////////////////////////////////////////  



import React, {useState} from "react"

import ContinuarComprando from  '../components/continuar_comprando';
import PrecoPictureQuantidadeFranqueado from  '../components/preco_picture_quantidade_franqueado';

import api from "../services/api";


function PedidosCliente() {

  // ESTADOS DEFINIDOS
    // 'pedidos' = LISTA DE PEDIDOS DO CLIENTE  

  let [pedidos, setPedidos] = useState([[]])


  if(!sessionStorage['login']){  // CASO NÃO ESTIVER LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']     
  }    
  else{
    if (sessionStorage['login'].includes('/')){  // OU ESTIVER LOGADO COMO FRANQUEADO E NÃO USUÁRIO
      window.location.href = '/?id=' + sessionStorage['loja']  // REDIRECIONA DE VOLTA PARA A HOME
    }
  }

  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/pedidos_cliente')

    search_pedidos()  // CHAMA A FUNÇÃO DE BUSCAR PEDIDOS
  }

  async function search_pedidos(){ // FUNÇÃO PARA BUSCAR PEDIDOS
    // FUNÇÃO CHAMADA NO ONLOAD DESTA PÁGINA

    var id_loja = sessionStorage['login']  // DEFINE A LOJA
    var query_start = 0  // INICIA A SUBQUERY EM ZERO
    var query_end = 1   // E REALIZA A BUSCA EM SUQUERIES DE 1 PEDIDO

    var produtos_novo = []


    var break_bool = false  // BOOLEANO DEFINIRÁ QUANDO NÃO EXISTIREM MAIS SUBQUERIES
    while(!break_bool){

      var resp = await api.post('buscar_meus_pedidos',{  // BUSCA NO DB OS PEDIDOS DO CLIENTE
        "login": id_loja,
        "query_start": query_start,
        "query_end": query_end,
      }).then((response) => {
        return response
      })
      // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
        // 'data' -> LISTA COM 3 POSIÇÕES
          // 1a POSIÇÃO -> STRING COM O ID DO PEDIDO
          // 2a POSIÇÃO -> DATA DO PEDIDO
          // 3a POSIÇÃO -> STRING VAZIA CASO O PEDIDO NÃO FOI CANCELADO
                        // STRING 'PEDIDO CANCELADO' CASO O PEDIDO FOI CANCELADO
            
        // 'produtos' -> LISTA COM OS PRODUTOS DO PEDIDO
          // CADA ITEM DA LISTA É UMA LISTA COM 3 POSIÇÕES
          // 1a POSIÇÃO -> STRING COM A DESCRIÇÃO DO PRODUTO
          // 2a POSIÇÃO -> STRING COM A URL DA PRIMEIRA IMAGEM DO PRODUTO
          // 3a POSIÇÃO -> STRING COM O VALOR DA QUANTIDADE DE ITENS COMPRADOS DAQUELE PRODUTO

      // 'query_end' -> INT COM O VALOR DA POSIÇÃO DO FINAL DA SUBQUERY       
      
      query_start = (query_start + 1)  // DEFINE O COMEÇO DA PRÓXIMA SUBQUERY
      query_end = (resp.data.query_end)  // DEFINE O FINAL DA PRÓXIMA SUBQUERY

      if (!resp.data.data[0]){  // CASO O COMEÇO E FINAL DA SUBQUERY SEJAM IGUAIS
        break_bool = true  // TODOS OS PEDIDOS JÁ FORAM LISTADOS
      }
      
      else{  // CASO CONTRÁRIO
        var matriz = [resp.data.data, resp.data.produtos]  // JUNTA AS INFORMAÇÕES NOVAS COM AS ANTIGAS
        produtos_novo = produtos_novo.concat([matriz])
      }

      setPedidos(produtos_novo)  // DEFINE O ESTADO COM AS INFORMAÇÕES NOVAS
      
    }  
  }

  // CASO EXISTAM PRODUTOS
  if(pedidos[0].length > 0){  // RENDERIZA A PÁGINA

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
      // 'PrecoPictureQuantidadeFranqueado' -> CARD COM DESCRIÇÃO, QUANTIDADE E FOTO DE CADA PRODUTO

      return (
        <div>
          <div>
            <ContinuarComprando />
          </div>

          <div id="todos_os_produtos" class="custom-container mt-5 pt-5">
            <div class='mb-5'>
              {pedidos.map((block) => (
                <div class='my-3 mx-0 card-login p-2 w-100 border-gray'>
                  <div class="montserrat verde bold">Pedido:</div>
                  <div class="montserrat mb-1">{block[0][0][1]}</div>

                  <div class="montserrat verde bold">Produtos:</div>
                  <div class="d-flex flex-wrap justify-content-start mx-3 mt-3 px-0 pt-0 start-page custom-container-catalogo align-items-end">

                  {block[1].map((produto) => (
                    <div class="">
                      <PrecoPictureQuantidadeFranqueado dsc={produto[0]} img={produto[1]} qnt={produto[2]} />
                    </div>
                  ))}            
                  </div>

                  <div class="d-flex justify-content-end vermelha montserrat">{block[0][0][2]}</div>
                </div>
              ))}            
            </div>
          </div>
        </div>    
      )
  }

  // CASO CONTRÁRIO RENDERIZA APENAS A VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
  return(
    <div>
      <ContinuarComprando />
    </div>
  )
}


export default PedidosCliente;